import { useId } from 'react';

export const SearchGradient = () => {
  const uniqueId = useId();
  const paint0Id = `paint0_linear_20877_29960_${uniqueId}`;

  const paint0Url = `url(#${paint0Id})`;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10ZM14.5836 15.2908C13.3555 16.3556 11.753 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 11.7531 16.3556 13.3556 15.2907 14.5837L20.998 20.291L20.2909 20.9981L14.5836 15.2908Z"
        fill={paint0Url}
      />
      <defs>
        <linearGradient id={paint0Id} x1="2.23952" y1="6.53533" x2="23.9927" y2="15.961" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E60000" />
          <stop offset="0.541564" stopColor="#7029CC" />
          <stop offset="1" stopColor="#0F558C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
